export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const mediaUrl = (id) => (id ? `${API}/media/${id}` : null);
export const SOURCE_LABEL = (s) => (s === "own" ? "Egne tanker" : s);
export const LANG_LABEL = { no: "Norsk", en: "English", da: "Dansk" };
export const HTML_LANG = { no: "nb", en: "en", da: "da" };

export const fmtDate = (ts, lang) => {
  try {
    return new Date(ts).toLocaleDateString(lang === "en" ? "en-GB" : "nb-NO", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
};

// Chunked upload via an authorised axios instance. onProgress(0..1).
export async function uploadFile(ax, file, onProgress) {
  const type = file.type || (file.name.toLowerCase().endsWith(".vtt") ? "text/vtt" : "application/octet-stream");
  const { data: init } = await ax.post("/admin/blog/upload/init", { filename: file.name, content_type: type, size: file.size });
  const step = init.chunk_size;
  const total = Math.max(1, Math.ceil(file.size / step));
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * step, (i + 1) * step);
    await ax.put(`/admin/blog/upload/${init.upload_id}/chunk/${i}`, blob, { headers: { "Content-Type": "application/octet-stream" } });
    onProgress?.((i + 1) / (total + 1));
  }
  const { data } = await ax.post(`/admin/blog/upload/${init.upload_id}/complete`);
  onProgress?.(1);
  return data;
}
